import secureClient from 'lib/secure-client';
import exclusiveUrl from 'shared_js/helpers/urlHelper/exclusiveUrl';

/**
 * Get mitra Wallet 2.0 whitelist status, also used for mitra Wallet 2.0 traffic management
 * http://blueprint.bukalapak.io/exclusive/t/mitra-wallet~mitra~wallet~get~exclusive~mitra-wallet~whitelist
 */
function retrieveWhitelist({ productType }) {
  return this.get(`${exclusiveUrl}/mitra-wallet/whitelist`, 'user', {
    enableAuthHeader: true,
    params: {
      product_type: productType,
    },
  });
}

const exclusiveMitraWalletApi = secureClient(
  {
    retrieveWhitelist,
  },
  'xhrExclusiveMitraWalletApi',
);

export default exclusiveMitraWalletApi;
